import { createStore, applyMiddleware, compose } from "redux"
import rootReducer from "../reducers/index"
import msEs from '../translations/es.json'
import { addLocaleData } from 'react-intl'
import thunk from 'redux-thunk'
import esLocaleData from 'react-intl/locale-data/es'
import enLocaleData from 'react-intl/locale-data/en'
import { VERSION } from '../utils'

addLocaleData([
  ...esLocaleData,
  ...enLocaleData
])

function saveToLocalStorage(state) {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem('state', serializedState)
  } catch (e) { }
}

function loadFromLocalStorage() {
  try {
    const currentVersion = localStorage.getItem('version')
    if (currentVersion !== VERSION) {
      return undefined
    }
    const serializedState = localStorage.getItem('state')
    if (serializedState === null) return undefined
    return JSON.parse(serializedState)
  } catch (e) {
    return undefined
  }
}

const defaultLanguage = {
  intl: {
    defaultLocale: 'es',
    locale: 'es',
    messages: msEs,
  },
}

const persistedState = loadFromLocalStorage()

const store = createStore(
  rootReducer,
  persistedState
    ? persistedState
    : defaultLanguage,
  process.env.NODE_ENV === 'development'
    ? compose(applyMiddleware(thunk), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f)
    : applyMiddleware(thunk)
)

store.subscribe(() => saveToLocalStorage(store.getState()))

export default store